import * as React from 'react';
import { ICardProps } from '../types';

import cn from 'clsx';

import * as styles from '../styles.css';
import { IconArrowRight24, Label, IconHotLeads16, UIHeading2, UIText1 } from '@cian/ui-kit';

export const CardSmall: React.FC<ICardProps> = ({ title, description, hasLabel, onClick, children, className }) => {
  return (
    <div
      className={cn(styles['card'], styles['card-small'], onClick && styles['card-clickable'], className && className)}
      onClick={onClick}
    >
      {onClick && (
        <div className={styles['btn']}>
          <IconArrowRight24 color="primary_100" />
        </div>
      )}

      <div>
        {hasLabel && (
          <div className={styles['label']}>
            {' '}
            <Label
              icon={<IconHotLeads16 color="accent-negative-primary" />}
              color="accent-negative-primary"
              background="accent-negative-secondary"
            >
              Популярное
            </Label>
          </div>
        )}

        <UIHeading2 as="p">{title}</UIHeading2>
        <UIText1>{description}</UIText1>
      </div>

      {children}
    </div>
  );
};
